import React from 'react';

function InvoiceDetails() {
    return (
        <div>not done yet lol</div>
    );
}

export default InvoiceDetails;